import React, { useState } from 'react'
import { Tabs, Tab, Typography, Box, useMediaQuery } from '@mui/material'

import Statement from '../Statement'
import EarningStats from './EarningStats'
import IncomeStatement from './IncomeStatement'
import ReversedEarnings from './ReveresedEarnings'
import WithdrawalRequests from './WithdrawalRequests'
import ReversedUserWithdrawals from './ReversedUserWithdrawal'
import ChargesCard from '../Components/MobileStatementCards/ChargesCard'
import EarningCards from '../Components/MobileStatementCards/EarningsCard'
import SummaryCards from '../Components/MobileStatementCards/SummaryCards'
import WithdrawalCard from '../Components/MobileStatementCards/WithdrawalCards'
import ReversedEarningsCards from '../Components/MobileStatementCards/ReversedEarningsCards'
import ReversedUserWithdrawalCards from '../Components/MobileStatementCards/ReversedUserWithdrawalCards'

import './styles/PerformerStatement.css'
import BankIcon from '../../../images_new/icon/Payment/Bank.svg?react'
import DollarIcon from '../../../images_new/icon/Payment/Dollar.svg?react'
import GraphIcon from '../../../images_new/icon/Payment/6. articles.svg?react'

export const PerformerStatementTabs = [
  {
    id: 0,
    label: 'Earnings',
    table: <IncomeStatement />,
    icon: <DollarIcon className='mb-0 tab-icon' />,
    cards: <EarningCards />,
  },
  {
    id: 1,
    label: 'Charges',
    table: <Statement />,
    icon: <BankIcon className='mb-0 tab-icon' />,
    cards: <ChargesCard />,
  },
  {
    id: 2,
    label: 'Payouts',
    table: <WithdrawalRequests />,
    icon: <BankIcon className='mb-0 tab-icon' />,
    cards: <WithdrawalCard />,
  },
  {
    id: 3,
    label: 'Reversed Earnings',
    table: <ReversedEarnings />,
    icon: <DollarIcon className='mb-0 tab-icon' />,
    cards: <ReversedEarningsCards />,
  },
  {
    id: 4,
    label: 'Reversed Withdrawal',
    table: <ReversedUserWithdrawals />,
    icon: <DollarIcon className='mb-0 tab-icon' />,
    cards: <ReversedUserWithdrawalCards />,
  },
  {
    id: 5,
    label: 'Summary',
    table: <EarningStats />,
    icon: <GraphIcon className='mb-0 tab-icon' />,
    cards: <SummaryCards />,
  }
]

function TabPanel(props) {
  const { children, value, index, ...other } = props
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

function a11yProps(index) {
  return {
    id: `wrapped-tab-${index}`,
    'aria-controls': `wrapped-tabpanel-${index}`,
  }
}

const PerformerStatements = () => {
  const [selectedTab, setSelectedTab] = useState(0)
  const isMobile = useMediaQuery('(max-width: 48rem)')

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue)
  }

  return (
    <div className={`${isMobile && 'last-card-margin'} row row-12 mt-4`}
    style={{
      paddingBottom: isMobile && '100px'
    }}>
      <Tabs
        className='mx-sm-0 mx-md-0 mx-xl-4 w-100 statement-tabs'
        value={selectedTab}
        onChange={handleTabChange}
        centered={true}
        allowScrollButtonsMobile={true}
        variant={isMobile ? 'scrollable' : 'standard'}
        scrollButtons={false}
      >
        {PerformerStatementTabs.map((statement, index) => (
          <Tab
            key={`${statement.label}-${index}`}
            iconPosition='start'
            classes={{
              root: 'statement-tabs',
              labelIcon: 'tab-height',
              selected: 'selected-tab',
            }}
            disableRipple={true}
            label={statement.label}
            icon={statement.icon}
            {...a11yProps(index)}
          ></Tab>
        ))}
      </Tabs>
      {PerformerStatementTabs.map((panel, index) => (
        <TabPanel
          key={`${panel.id}-${index}`}
          value={selectedTab}
          index={index}
          className='table-panel px-xl-4'
        >
          {isMobile ? panel.cards : panel.table}
        </TabPanel>
      ))}
    </div>
  )
}

export default PerformerStatements
